import React, { useState, useMemo } from "react";
import IconButton from "@mui/material/IconButton";
import { Menu, MenuItem, AppBar, Toolbar, Box, Avatar, Typography } from "@mui/material";
import { useGlobalContext } from "../../../context/Appcontext";
import { useLocation } from "react-router-dom";
import arrowDown from "../../../assets/arrowDown.svg";
import logoutIcon from "../../../assets/logout.svg";
import drBot from "../../../assets/drBot.png";
import salesBot from "../../../assets/salesBot.png";

const getRandomColor = () => {
  const colors = ["#3878D1", "#E39121", "#4CAF50", "#FF5722", "#9C27B0"];
  return colors[Math.floor(Math.random() * colors.length)];
};

const Header: React.FC = () => {
  const location = useLocation();
  const { user, logout } = useGlobalContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const botDetails = location.pathname === "/sales" ? {img:salesBot, name: "Sales Chatbot"} : {img:drBot, name:"Dr. Chat AI"};

  const avatarBgColor = useMemo(() => getRandomColor(), [user]);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <AppBar position="fixed" sx={styles.appBar}>
      <Toolbar>
        <div style={styles.bot}>
          <div>
          <img src={botDetails.img} alt="bot avatar" style={styles.botImage} />
          <div style={styles.statusIndicator} />
          </div>
          <div>
            <Typography sx={{fontSize:"14px", fontWeight:"600",whiteSpace: "nowrap"}}>{botDetails.name}</Typography>
            <Typography sx={{fontSize:"12px",fontStyle:"italic",opacity:"0.5"}}>Beta</Typography>
          </div>
        </div>
        <Box sx={styles.toolbar}>
          <Avatar sx={{ ...styles.avatar, backgroundColor: avatarBgColor }} alt={user?.username}>
            {user?.username?.charAt(0).toUpperCase() || "U"}
          </Avatar>
          <Typography sx={{ mx: 1 }}>{user?.username}</Typography>
          <IconButton onClick={handleMenuOpen} sx={styles.arrowButton}>
            <img src={arrowDown} alt="arrowDown" />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            PaperProps={{
              sx: {
                marginTop: "8px",
                marginLeft: "-12px",
                boxShadow: 'none',
                backgroundColor: 'transparent',
                '& .MuiList-root': {
                  backgroundColor: 'transparent',
                }
              }
            }}
          >
            <MenuItem
              onClick={handleLogout}
              sx={{
                borderRadius: "24px 4px 24px 24px",
                background: "#FFF",
                boxShadow: "0 2px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)",
                padding: "12px 24px",
                border: "1px solid #E5E5E5",
              }}
            >
              <img
                style={{
                  marginRight: "10px",
                }}
                src={logoutIcon} alt="logout" />
              Logout</MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

const styles = {
  appBar: {
    boxShadow: "none",
    backgroundImage: "none",
    backgroundColor: "transparent",
    color: "#000",
    width: "calc(100% - 360px)",
    marginLeft: "360px",
  },
  toolbar: {
    display: "flex",
    justifyContent: "end",
    alignItems: "center",
    width: "100%",
    color: "#000",
  },
  avatar: {
    cursor: "pointer",
  },
  arrowButton: {
    color: "#000",
  },
  menu: {
    mt: 1,
  },
  bot:{
    display:"flex",
    gap:"10px",
    margin:"20px"
  },
  botImage: {
    position: "relative" as "relative",
    width: "38px",
    height: "38px",
    borderRadius: "50%",
    objectFit: "cover" as "cover",
  },
  statusIndicator: {
    position: "absolute" as "absolute",
    top: 47,
    left: 71,
    width: "14px",
    height: "14px",
    backgroundColor: "#25EF0E", /* green */
    border: "2px solid #fff",
    borderRadius: "50%"
  }
};

export default Header;
